import React, { useState } from "react";
import { CommonButton, CommonModal, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";
import { Eye, Edit, Delete, Trash } from "lucide-react";
import CreateTemplateModal from "./CreateTemplateModal";
import Swal from "sweetalert2";

/**
 * SelectTemplateModal - Modal to select a bulk transaction template
 */
const SelectTemplateModal = ({ show, onHide, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedForEdit, setSelectedForEdit] = useState(null);

  const mockTemplates = [
    {
      id: 1,
      name: "test151",
      numReceivers: 3,
      createdBy: "--",
      createdAt: "11/03/2026\n17:24:42",
    },
    {
      id: 2,
      name: "test15",
      numReceivers: 2,
      createdBy: "--",
      createdAt: "11/03/2026\n17:17:20",
    },
  ];

  const columns = [
    {
      label: "Template Name",
      key: "name",
      render: (item) => <span className="text-black">{item.name}</span>,
    },
    {
      label: "Number of Receivers",
      key: "numReceivers",
      className: "text-center",
      headerClassName: "text-center",
    },
    {
      label: "Created By",
      key: "createdBy",
      className: "text-center",
      headerClassName: "text-center",
    },
    {
      label: "Created At",
      key: "createdAt",
      className: "text-center",
      headerClassName: "text-center",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Actions",
      key: "actions",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <div className="d-flex justify-content-center gap-2">
          <button
            className="btn btn-primary p-0 rounded d-flex align-items-center justify-content-center bg-opacity-10 border-0"
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "rgba(30, 170, 231, 0.1)",
              color: "#1eaae7",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedForEdit(row);
              setShowCreateModal(true);
            }}
          >
            <Edit size={16} />
          </button>
          <button
            className="btn btn-danger p-0 rounded d-flex align-items-center justify-content-center bg-opacity-10 border-0"
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "rgba(255, 94, 94, 0.1)",
              color: "#ff5e5e",
            }}
            onClick={(e) => {
              e.stopPropagation();
              Swal.fire({
                title: "Are you sure?",
                text: "You will not be able to recover this template!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ff5e5e",
                cancelButtonColor: "#B9B9B9",
                confirmButtonText: "Yes, delete it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  Swal.fire({
                    title: "Deleted!",
                    text: "Your template has been deleted.",
                    icon: "success",
                    confirmButtonColor: "var(--primary)",
                  });
                }
              });
            }}
          >
            <Trash size={16} />
          </button>
        </div>
      ),
    },
  ];

  const filteredTemplates = mockTemplates.filter((t) =>
    t.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title="Select Template"
      size="xl"
      bodyClassName="bg-white"
      headerClassName="border-bottom pb-3"
      footer={
        <div className="w-100 text-end px-3">
          <CommonButton
            variant="outline"
            className="px-4 border-light-gray h-40"
            style={{ borderColor: "#ddd", borderRadius: "8px" }}
            onClick={() => {
              setSelectedForEdit(null);
              setShowCreateModal(true);
            }}
          >
            Create Template
          </CommonButton>
        </div>
      }
    >
      <div>
        <div className="mb-4" style={{ maxWidth: "250px" }}>
          <label className="text-muted fs-12 mb-1">Name</label>
          <CommonInput
            placeholder="Enter name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div>
          <DataTable
            columns={columns}
            data={filteredTemplates}
            showPagination={false}
            onRowClick={(item) => onSelect && onSelect(item)}
            minWidth="100%"
            rowClassName={() => "cursor-pointer"}
          />
        </div>
      </div>

      <CreateTemplateModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        template={selectedForEdit}
      />
    </CommonModal>
  );
};

export default SelectTemplateModal;
